import { useQuery } from '@tanstack/react-query';
import { getGetPhaseIdProjectQueryKey, getPhaseIdProject } from '../api/phase-api/phase-api';
import { PhaseDto } from '../api/model';

export const useProjectPhases = (projectId?: number) => {
  return useQuery({
    queryKey: projectId ? getGetPhaseIdProjectQueryKey(projectId) : ['phases', 'empty'],
    queryFn: async ({ signal }) => {
      if (!projectId) return [] as PhaseDto[];
      return await getPhaseIdProject(projectId, signal);
    },
    enabled: !!projectId,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};